import { render, staticRenderFns } from "./ESoa.vue?vue&type=template&id=67c09d2a&scoped=true&lang=pug"
import script from "./ESoa.vue?vue&type=script&lang=js"
export * from "./ESoa.vue?vue&type=script&lang=js"
import style0 from "./ESoa.vue?vue&type=style&index=0&id=67c09d2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c09d2a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default})
